/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A person of the insured risk in the quote summary.
 * @export
 * @interface DevisResumeSouscripteurDto
 */
export interface DevisResumeSouscripteurDto {
    /**
     * 
     * @type {string}
     * @memberof DevisResumeSouscripteurDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisResumeSouscripteurDto
     */
    email?: string | null;
}

/**
 * Check if a given object implements the DevisResumeSouscripteurDto interface.
 */
export function instanceOfDevisResumeSouscripteurDto(value: object): value is DevisResumeSouscripteurDto {
    return true;
}

export function DevisResumeSouscripteurDtoFromJSON(json: any): DevisResumeSouscripteurDto {
    return DevisResumeSouscripteurDtoFromJSONTyped(json, false);
}

export function DevisResumeSouscripteurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevisResumeSouscripteurDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nom': json['nom'] == null ? undefined : json['nom'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function DevisResumeSouscripteurDtoToJSON(json: any): DevisResumeSouscripteurDto {
    return DevisResumeSouscripteurDtoToJSONTyped(json, false);
}

export function DevisResumeSouscripteurDtoToJSONTyped(value?: DevisResumeSouscripteurDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nom': value['nom'],
        'email': value['email'],
    };
}

